<template>
  <div>
    <div class="row checkBoxControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :for="control.name + '_gui_control'"
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <b-form-checkbox
          type="checkbox"
          :readonly="this.control.readonly"
          :name="control.fieldName"
          v-model="control.value"
          @change="changed"
          :disabled="control.readonly"
        />
      </div>
    </div>
    <div v-else>
      <label
        :for="control.name + '_gui_control'"
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>

      <div>
        <b-form-checkbox
          type="checkbox"
          :readonly="this.control.readonly"
          :name="control.fieldName"
          v-model="control.value"
          @change="changed"
          :disabled="control.readonly"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'

export default {
  name: 'CheckboxControl',
  props: ['control', 'labelPosition'],
  methods: {
    changed() {
      this.$nextTick(() => {
        const fbInst = this.$instByClass(this, 'form-builder-root')

        fbInst.setRowDataVal(this.control.propName, this.control.value)
      })
    },
  },
  mounted() {
    // after hook
    Hooks.Control.afterInit.run(this.control, $(this.$el).find('input'))
  },
}
</script>
